import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeRequestTableRow, RequestTypeEnum } from "../types";

export const useChangesNavigation = (row: ChangeRequestTableRow) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOnClick = useCallback(() => {
    if (row.requestType === RequestTypeEnum.REMOVE_SUPPLY) {
      navigate(`/remove-supply/${row.id}`, {
        state: {
          serviceType: row.serviceType,
          backUrl: location.pathname + location.search,
        },
      });
    } else {
      navigate(`/change-request/${row.id}`, {
        state: {
          serviceType: row.serviceType,
          backUrl: location.pathname + location.search,
        },
      });
    }
  }, [
    row.requestType,
    row.id,
    row.serviceType,
    location.pathname,
    location.search,
  ]);
  return { handleOnClick, navigate, location };
};
